export default __webpack_public_path__ + "static/media/odciskprzed.18d56824.jpeg";